import { render, staticRenderFns } from "./addDomain.vue?vue&type=template&id=03a443da&scoped=true"
import script from "./addDomain.vue?vue&type=script&lang=js"
export * from "./addDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a443da",
  null
  
)

export default component.exports